import React from 'react';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { StreamingProvider } from './context/StreamingContext';
import { NotificationProvider } from './context/NotificationContext';
import { ImpersonationProvider } from './context/ImpersonationContext';
import { RequireAuth } from './components/RequireAuth';
import { ProtectedShell } from './components/ProtectedShell';
import { MainEditorView } from './components/MainEditorView';
import './styles/App.css';

const AppContent: React.FC = () => {
  return (
    <RequireAuth>
      <ProtectedShell>
        <MainEditorView />
      </ProtectedShell>
    </RequireAuth>
  );
};

function App() {
  return (
    <AuthProvider>
      <ImpersonationProvider>
        <StreamingProvider>
          <NotificationProvider>
            <AppProvider>
              <div className="app-shell">
                <div className="app-main-content">
                  <AppContent />
                </div>
              </div>
            </AppProvider>
          </NotificationProvider>
        </StreamingProvider>
      </ImpersonationProvider>
    </AuthProvider>
  );
}

export default App;
